<template>
  <v-row
    justify="center"
    align="center"
    class="player-wrapper rounded-2 ma-0 pa-3"
    :style="
      $vuetify.theme.dark
        ? 'background-color: #1E1E1E;'
        : 'background-color: white;'
    "
  >
    <v-col cols="12" hidden>
      <audio ref="player" preload="metadata">
        <source :src="mediaUrl" />
      </audio>
    </v-col>

    <v-col cols="auto" class="pa-0">
      <div
        class="play-button d-flex justify-center align-center hand-cursor"
        @click="togglePlayPause"
      >
        <div class="inner-circle d-flex justify-center align-center">
          <v-icon size="30" color="white">
            {{ isPlaying ? "mdi-pause" : "mdi-play" }}
          </v-icon>
        </div>
      </div>
    </v-col>

    <v-col align="start" class="pb-0 pe-0">
      <v-row>
        <v-col class="py-0">
          <span class="caption textLight--text">{{ title }}</span>
        </v-col>

        <v-col cols="auto" class="py-0">
          <span
            class="
              caption
              textLight--text
              font-weight-medium
              rounded-2
              px-2
              py-1
              hand-cursor
            "
            :style="
              $vuetify.theme.dark
                ? 'background-color: #141313;'
                : 'background-color: #f5f1ff;'
            "
            @click="togglePlayingSpeed"
          >
            {{ currentSpeed }}x
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="py-0">
          <v-slider
            v-model="playerSeekBarValue"
            track-color="grey"
            color="primary"
            min="0"
            :max="playerSeekBarMaxValue"
            hide-details
            class="ma-0"
            @change="changePlayerCurrentTime"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="py-0">
          <span class="caption textLight--text">{{ elapsedTime }}</span>
        </v-col>

        <v-spacer />

        <v-col align="end" class="py-0">
          <span class="caption textLight--text">{{ totalTime }}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    mediaUrl: String,
    title: String,
  },
  data() {
    return {
      player: null,
      isPlaying: false,
      canPlay: false,
      playerSeekBarValue: 0,
      playerSeekBarMaxValue: 100,
      currentSpeed: 1,
      totalTime: "00:00",
      elapsedTime: "00:00",
    };
  },
  watch: {
    mediaUrl(newValue) {
      this.isPlaying = false;
      this.canPlay = false;
      this.playerSeekBarValue = 0;
      this.playerSeekBarMaxValue = 100;
      this.currentSpeed = 1;
      this.totalTime = "00:00";
      this.elapsedTime = "00:00";

      if (this.player) {
        this.player.src = newValue;
        this.player.load();
      }
    },
  },
  mounted() {
    this.player = this.$refs["player"];

    if (this.player) {
      const calculateTime = seconds => {
        this.$emit("onReady", Math.ceil(seconds / 60));
        return this.$moment.utc(seconds * 1000).format("mm:ss");
      };

      this.player.addEventListener("canplay", () => {
        this.canPlay = true;
      });

      this.player.addEventListener("timeupdate", () => {
        this.playerSeekBarValue = Math.floor(this.player.currentTime);
        this.elapsedTime = calculateTime(this.player.currentTime);

        if (this.player.ended) {
          this.$emit("onEnd");
        }
      });

      this.player.addEventListener("progress", () => {
        //TODO: buffered audio value
      });

      this.player.addEventListener("play", () => {
        this.isPlaying = true;
      });

      this.player.addEventListener("pause", () => {
        this.isPlaying = false;
      });

      if (this.player.readyState > 0) {
        this.totalTime = calculateTime(this.player.duration);
        this.playerSeekBarMaxValue = Math.floor(this.player.duration);
      } else {
        this.player.addEventListener("loadedmetadata", () => {
          this.totalTime = calculateTime(this.player.duration);
          this.playerSeekBarMaxValue = Math.floor(this.player.duration);
        });
      }
    }
  },
  methods: {
    togglePlayPause() {
      if (this.player) {
        if (this.player.paused) {
          this.player.play();
          this.isPlaying = true;
        } else {
          this.player.pause();
          this.isPlaying = false;
        }
      }
    },
    changePlayerCurrentTime(value) {
      if (this.player) {
        this.player.currentTime = value;
      }
    },
    togglePlayingSpeed() {
      if (this.player) {
        if (this.currentSpeed < 2) {
          this.currentSpeed += 0.5;
        } else {
          this.currentSpeed = 0.5;
        }

        this.player.playbackRate = this.currentSpeed;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.player-wrapper {
  position: relative;
  width: 100%;
}
.play-button {
  border-radius: 50%;
  height: 55px;
  width: 55px;
  background-color: rgba(89, 40, 229, 0.3);
}
.inner-circle {
  border-radius: 50%;
  height: 40px;
  width: 40px;
  background-color: rgba(89, 40, 229);
}
</style>
